import React from 'react';

import '../../common/css/global.css';
import './ImpactPage.css'
import '../../common/components/impact/WideImpactCounter.css'
import '../../common/components/impact/merchant-config/default-dashboard-impact.css'
import ccLogo from '../../common/media/cc_logo_white.svg'
import ccIcon from '../../common/media/cc-icon-white.svg'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { formatNumber } from "../../common/util/numberFormatter";

const ImpactPage = ({ fetchedImpact }) => {
    return (
        <div className="impact-container">
            <main className="impact-content">
                <article className="project-carousel">
                    {fetchedImpact?.projects?.map ? (
                        <Carousel autoPlay infiniteLoop showThumbs={false} interval={7000}>
                            {fetchedImpact?.projects?.map(p => (
                                <div key={p.id} className="project-carousel-slide">
                                    <div className="project-img vertical-align-parent">
                                        <div className="vertical-align">
                                            <img className="mw-100" src={p.imageUrl || p.thumbnailImageUrl} />
                                        </div>
                                    </div>

                                    <h4>{p.name}</h4>
                                    {/*<small>Specify project location here</small>*/}
                                </div>
                            ))}
                        </Carousel>
                        ) : fetchedImpact?.error ? (
                           <div className="d-grid h-100p">
                               <span className="m-auto">Error occurred while loading projects.</span>
                           </div>
                        ) : (
                           <div className="d-grid h-100p">
                               <span className="m-auto">Loading...</span>
                           </div>
                    ) }

                </article>
                <article className="impact-counters">
                    {/*<LiveImpacts impact={fetchedImpact} merchantCode="BES_NZ_PITA_PIT"/>*/}
                    <div class="live-impacts pitapit-style">
                        <section class="wide-impact-counter bg-primary color-white">
                            <h1 className="pacifico-font">{formatNumber(fetchedImpact?.impactProgress?.lunches?.currentCount)}</h1>
                            <h4 className="font-bold">Climate Friendly Lunches</h4>
                        </section>
                        <section class="wide-impact-counter bg-primary color-white">
                            <h1 className="pacifico-font">{formatNumber(fetchedImpact?.impactProgress?.carbonOffset?.currentCount)}</h1>
                            <h4 className="font-bold">Kg of CO2 Offset</h4>
                        </section>
                        <section class="wide-impact-counter bg-primary color-white">
                            <h1 className="pacifico-font">{formatNumber(fetchedImpact?.impactProgress?.treeGrowthYears?.currentCount)}</h1>
                            <h4 className="font-bold">Trees</h4>
                        </section>
                    </div>
                </article>
            </main>
            <footer className="impact-footer shadow">
                <img className="m-1" src="https://res.cloudinary.com/carbonclick/image/upload/v1608606692/Enterprise/PitaPit/Logo_a9wm5w.svg" alt="Pita Pit" height={50} />
                <div className="impact-footer" style={{textAlign: "right"}}>
                    <small className="powered-by mr-3 mobile-hide">POWERED BY</small>
                    <img className='mobile-hide' src={ccLogo} alt="CarbonClick" height={30}/>
                    <img className='mobile-show' src={ccIcon} alt="CarbonClick" height={30}/>
                </div>
            </footer>
        </div>
    )
};


export default ImpactPage;